import React from 'react';
import errorBoundary from '@ifeng/errorBoundary';
import Style from './index.css';

const Prev = () => {
    return (
        <div className={Style.prev}>
            <a href="https://v.ifeng.com/special/zgtyyxlm/" target="_blank">
                <img src="https://x0.ifengimg.com/ucms/2022_44/1A13C9E05D4F9DFCD87FB6DA0A1B397333376E85_size21_w944_h117.jpg" alt="" />
            </a>
            <a href="https://v.ifeng.com/c/special/7ygoLTjBZp2" target="_blank">
                <img src="https://x0.ifengimg.com/ucms/2022_44/3C93295B30DA55011398EF7CB303163EEFC39688_size23_w944_h117.jpg" alt="" />
            </a>
            <a href="https://v.ifeng.com/c/special/883i57YVyEa" target="_blank">
                <img src="https://x0.ifengimg.com/ucms/2022_44/BB00A0FEB53A0163BFE66A9873578909479B054A_size22_w944_h117.jpg" alt="" />
            </a>
        </div>
    );
};

export default errorBoundary(Prev);
